module.exports = __webpack_public_path__ + "static/media/give-love.e9516977.png";